import { render, staticRenderFns } from "./deliverymanagement.vue?vue&type=template&id=9a387098&scoped=true&"
import script from "./deliverymanagement.vue?vue&type=script&lang=js&"
export * from "./deliverymanagement.vue?vue&type=script&lang=js&"
import style0 from "./deliverymanagement.vue?vue&type=style&index=0&id=9a387098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a387098",
  null
  
)

export default component.exports